/**
 * Applies an ADSR envelope to a GainNode.
 *
 * @param {GainNode}     gainNode
 * @param {AudioContext} ctx
 * @param {object}       env      - { attack, decay, sustain, release } (seconds / level)
 * @param {number}       peak     - Peak gain level (0–1)
 */
export function applyADSR(gainNode, ctx, env, peak = 1.0) {
    const g = gainNode.gain;
    const now = ctx.currentTime;

    g.cancelScheduledValues(now);
    g.setValueAtTime(0, now);

    // Attack: ramp up to peak
    g.linearRampToValueAtTime(peak, now + env.attack);

    // Decay: ramp down to sustain level
    g.linearRampToValueAtTime(peak * env.sustain, now + env.attack + env.decay);

    // Sustain level is held until stopADSR() triggers the release
}

/**
 * Triggers the release phase of an ADSR on a GainNode.
 * Returns the absolute time when the signal reaches zero.
 *
 * @param {GainNode}     gainNode
 * @param {AudioContext} ctx
 * @param {object}       env      - { release } (seconds)
 * @returns {number}  AudioContext time when gain reaches 0
 */
export function releaseADSR(gainNode, ctx, env) {
    const g = gainNode.gain;
    const now = ctx.currentTime;
    g.cancelScheduledValues(now);
    g.setValueAtTime(g.value, now);
    g.linearRampToValueAtTime(0, now + env.release);
    return now + env.release;
}
